import { VoiceConversationHistoryItemDto } from "./VoiceConversationHistoryItemDto";
import { VoiceConversationHistoryItemModel } from "./VoiceConversationHistoryItemModel";

type VoiceConversationHistoryPayload = {
  media_id: string;
  summary: string;
  topic: string;
  started_at?: string;
  ended_at?: string;
};

const asString = (value: unknown): string =>
  typeof value === "string" ? value : "";

const asOptionalString = (value: unknown): string | undefined =>
  typeof value === "string" && value ? value : undefined;

export const transformVoiceConversationHistoryItemDtoToModel = (
  dto: VoiceConversationHistoryItemDto
): VoiceConversationHistoryItemModel => {
  let parsedPayload: unknown = null;

  try {
    parsedPayload = JSON.parse(dto.payload);
  } catch {
    // Skip
  }

  // `JSON.parse` happily returns `null`, a number or a string for a valid but
  // unexpected payload — reading properties off those would throw inside
  // `transformResponse` and fail the whole query, not just one row
  const payload = (
    typeof parsedPayload === "object" && parsedPayload !== null
      ? parsedPayload
      : {}
  ) as Partial<Record<keyof VoiceConversationHistoryPayload, unknown>>;

  return {
    mediaId: asString(payload.media_id),
    insertedAt: asString(dto.inserted_at),
    summary: asOptionalString(payload.summary),
    topic: asOptionalString(payload.topic),
    startedAt: asOptionalString(payload.started_at),
    endedAt: asOptionalString(payload.ended_at),
  };
};
